import React, { useId } from "react";
import { validateTariffCode } from "../../../utils/Validators";

export default function HtsInput({ id, label, value = "", onChange }) {
  const errorId = useId();
  const invalid = !validateTariffCode(value.replace(/[.\s]/g, ""));
  return (
    <div className="premium-hts-input">
      <input
        id={id}
        aria-label={label}
        aria-invalid={invalid}
        aria-describedby={invalid ? errorId : undefined}
        className={`form-control${invalid ? " is-invalid" : ""}`}
        value={value}
        maxLength={100}
        onChange={onChange}
      />
      {invalid && (
        <div id={errorId} className="invalid-feedback">
          Kod HTS musi zawierać 4, 6, 8 lub 10 cyfr. Kropki i spacje nie są
          liczone.
        </div>
      )}
    </div>
  );
}
